import { useTranslation } from 'react-i18next';
import useUserDetails from '../../../../hooks/api/users/useUserDetails';
import { routes } from '../../../../static/routes';
import { colors } from '../../../../styles/variables';
import UserIcon from '../../../icons/UserIcon';
import NavButton from '../NavButton';

const NavButtonAccount = () => {
  const { t } = useTranslation();
  const { user } = useUserDetails();

  const getUserAccountIcon = ({ isActive }: { isActive?: boolean }) => {
    if (user?.avatar) {
      return (
        <div className="rounded-full bg-grey100 h-6 w-6 flex justify-center items-center object-contain">
          <img src={user.avatar} alt="avatar" className="rounded-full" />
        </div>
      );
    } else {
      return <UserIcon small color={isActive ? colors.white900 : colors.grey700} />;
    }
  };

  return (
    <NavButton
      href={routes.accountPersonalData}
      text={t('navigation.account')}
      icons={{
        default: getUserAccountIcon({}),
        active: getUserAccountIcon({ isActive: true }),
      }}
    />
  );
};

export default NavButtonAccount;
